<template>
  <div class="tooltip" :class="{ active: tooltip.active }" :style="{ top: tooltip.top + 'px', left: tooltip.left + 'px' }">
    {{ tooltip.content }}
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['tooltip'])
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/variables.scss';
.tooltip {
  position: fixed;
  top: -50px;
  left: -50px;
  color: #ffffff;
  background: $primary-color;
  opacity: 0;
  padding: 8px 12px;
  border-radius: 4px;
}
.tooltip.active {
  opacity: .9;
  transition: opacity .2s linear 1s;
}

</style>